import {
  UPDATE_ORDER,
  UPDATE_MAX_STEP,
  UPDATE_CURRENT_STEP,
  UPDATE_STATUS_STATE
} from "../actions/order";

export default function order(
  state = {
    currentStep: 1,
    maxStep: 1,
    data: {
      first_name: "",
      second_name: "",
      date: "",
      location: "",
      template: ""
    },
    status: null
  },
  action
) {
  switch (action.type) {
    case UPDATE_ORDER:
      return {
        ...state,
        data: action.data
      };
    case UPDATE_MAX_STEP:
      return {
        ...state,
        maxStep: action.step || 1
      };
    case UPDATE_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.step
      };
    case UPDATE_STATUS_STATE:
      return {
        ...state,
        status: action.status
      };

    default:
      return state;
  }
}
